import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const getPageDetails = (pathname: string) => {
  if (pathname.match(/\/signin/)) return { category: 'Signup App', name: 'Login' };
  if (pathname.match(/\/signup\/complete$/)) return { category: 'Signup App', name: 'Company Details' };
  if (pathname.match(/\/signup\/coming-soon$/)) return { category: 'Signup App', name: 'ROW Waiting List' };
  if (pathname.match(/\/signup\/sso-error$/)) return { category: 'Signup App', name: 'SSO Error' };
  if (pathname.match(/\/signup\/mobile\/success$/)) return { category: 'Signup App', name: 'Mobile Waiting List Success' };
  if (pathname.match(/\/signup\/mobile$/)) return { category: 'Signup App', name: 'Mobile Waiting List' };
  if (pathname.match(/\/signup$/)) return { category: 'Signup App', name: 'Signup Homepage' };
  return { category: 'Signup App', name: 'Unknown' };
};

/**
 * Tracks SPA route changes to Pensieve via VQClientMetrics (loaded by BE template).
 * Safely no-ops if PensieveMetrics is not available.
 */
export const OnRouteChange = () => {
  const alreadyCalled = useRef(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (window.PensieveMetrics?.trackPageView && alreadyCalled.current) {
      const { category, name } = getPageDetails(pathname);
      window.PensieveMetrics.trackPageView({ category, name });
    }

    if (!alreadyCalled.current) alreadyCalled.current = true;
  }, [pathname]);

  return null;
};
